/**
 * Utility functions extracted from ArchiveDetails.tsx
 */

/**
 * Checks if a value is odd and within a given range
 */
export const isOddAndInRange = (
  value: number,
  min: number,
  max: number
): boolean => value % 2 !== 0 && value >= min && value <= max;

/**
 * Merges documents and videos arrays based on filter.
 * Returns the merged array.
 */
export function handleMergedCollection(
  documents: unknown[],
  videos: unknown[],
  archiveCollectionName?: string
): unknown[] {
  let mergedCollection: unknown[] = [];

  if (
    Array.isArray(documents) &&
    documents.length > 0 &&
    Array.isArray(videos) &&
    videos.length > 0
  ) {
    if (!archiveCollectionName || mergedCollection.length === 0) {
      mergedCollection = [...documents, ...videos];
    }

    if (archiveCollectionName === "video") {
      mergedCollection = videos;
    }

    if (archiveCollectionName === "documents") {
      mergedCollection = documents;
    }
  }

  return mergedCollection;
}

/**
 * Transforms vimeo API data into a videoId -> thumbnailLink map
 */
export function buildVimeoImageMap(
  videosVimeo: Array<{
    uri: string;
    pictures: {
      sizes: Array<{ link: string }>;
    };
  }>,
  imgIndex: number
): Record<string, string> {
  if (!Array.isArray(videosVimeo) || videosVimeo.length < 1) {
    return {};
  }

  return videosVimeo.reduce(
    (acc, video) => {
      const videoId = video.uri.replace("/videos/", "");
      const thumbnailLink = video.pictures.sizes[imgIndex]?.link;

      if (thumbnailLink) {
        acc[videoId] = thumbnailLink;
      }

      return acc;
    },
    {} as Record<string, string>
  );
}
